import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Jupiter from '../NoData_Jupiter';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";

function RealWorldBar_Jupiter({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<=100": { per: 0, count: 0 },
      "110": { per: 0, count: 0 },
      "120": { per: 0, count: 0 },
      "130": { per: 0, count: 0 },
      "140": { per: 0, count: 0 },
      "150": { per: 0, count: 0 },
      "160": { per: 0, count: 0 },
      "170": { per: 0, count: 0 },
      "180": { per: 0, count: 0 },
      ">180": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {
      let t_val = res_result[0];
      if (t_val.doc_count != 0) {
        if (t_val.less_100.sum > 0) {
          responce["<=100"] = { per: parseInt(t_val.less_100.avg * 100), sum: parseInt(t_val.less_100.sum) };
        }
        if (t_val.less_110.sum > 0) {
          responce["110"] = { per: parseInt(t_val.less_110.avg * 100), sum: parseInt(t_val.less_110.sum) };
        }
        if (t_val.less_120.sum > 0) {
          responce["120"] = { per: parseInt(t_val.less_120.avg * 100), sum: parseInt(t_val.less_120.sum) };
        }
        if (t_val.less_130.sum > 0) {
          responce["130"] = { per: parseInt(t_val.less_130.avg * 100), sum: parseInt(t_val.less_130.sum) };
        }
        if (t_val.less_140.sum > 0) {
          responce["140"] = { per: parseInt(t_val.less_140.avg * 100), sum: parseInt(t_val.less_140.sum) };
        }
        if (t_val.less_150.sum > 0) {
          responce["150"] = { per: parseInt(t_val.less_150.avg * 100), sum: parseInt(t_val.less_150.sum) };
        }
        if (t_val.less_160.sum > 0) {
          responce["160"] = { per: parseInt(t_val.less_160.avg * 100), sum: parseInt(t_val.less_160.sum) };
        }
        if (t_val.less_170.sum > 0) {
          responce["170"] = { per: parseInt(t_val.less_170.avg * 100), sum: parseInt(t_val.less_170.sum) };
        }
        if (t_val.less_180.sum > 0) {
          responce["180"] = { per: parseInt(t_val.less_180.avg * 100), sum: parseInt(t_val.less_180.sum) };
        }
        if (t_val.greater_180.sum > 0) {
          responce[">180"] = { per: parseInt(t_val.greater_180.avg * 100), sum: parseInt(t_val.greater_180.sum) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys = ["<=100", "110", "120", "130", "140", "150", "160", "170", "180", ">180"]

        loop_keys.map(x => {
          if (x != "2e6334e2" && x != "doc_count") {
            // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].sum + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#348393"]);
            res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].sum + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;color:#348393"]);
          }
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: 'Range',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Discharge Cycles',
      minValue: 0,
      format: '#\'%\'',
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  return (
    <>
      <div className=" p-2">
        <div className="v-title">
          <div className="chartHGT">
            <WaterMark />
            {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} />)}
          </div>
        </div>
      </div>
    </>
  );
}

export default RealWorldBar_Jupiter;